import { Component } from 'san';
import * as _ from 'lodash';
import { ICheckUsersCallback, IShowCheckUsersParams, IUser, IUsersParams } from 'src/models';
import userService from 'src/services/user.service';
import Pagination from '../Pagination/Pagination';

export default class CheckUsers extends Component {
    static components = {
        'ui-pagination': Pagination
    }

    static computed = {
        checkedUsers() {
            const users = this.data.get('users');
            return _.filter(users, { _is_checked: true });
        },
        isCheckedAll() {
            const users = this.data.get('users');
            const checkedUsers = _.filter(users, { _is_checked: true });
            return checkedUsers.length > 0 && checkedUsers.length === users.length;
        }
    }

    constructor(options: any) {
        super(options);
    }

    initData(): {
        isShow: boolean;
        isMultiple: boolean;
        checkedUsers: IUser[];
        disabledUsers: IUser[];
        callback: ICheckUsersCallback;
        // 内部属性
        q: string;
        isLately: boolean;
        users: IUser[];
        count: number;
        page: number;
        limit: number;
    } {
        return {
            checkedUsers: [],
            disabledUsers: [],
            isShow: false,
            isMultiple: false,
            callback: null,
            q: '',
            isLately: true,
            users: [],
            count: 0,
            page: 1,
            limit: 10
        };
    }

    inited() {
    }

    //#region owner调用
    show(params?: IShowCheckUsersParams) {
        this.data.set('isMultiple', !!params && params.isMultiple);
        this.data.set('disabledUsers', params && params.disabledUsers || []);
        this.data.set('callback', params && params.callback);
        this.data.set('q', '');
        this.data.set('isLately', true);
        this.data.set('count', 0);
        this.data.set('page', 1);
        const users = this.data.get('users');
        this.data.splice('users', [0, users.length]);
        this.data.set('isShow', true);
        this.getLatelyUsers();
    }
    //#endregion

    private getLatelyUsers() {
        userService.getLatelyUsers().then(users => {
            const oldUsers = this.data.get('users');
            users = this.rejectDisabledUsers(users);
            this.data.splice('users', [0, oldUsers.length, ...users]);
        });
    }

    search() {
        this.data.set('isLately', false);
        this.goToPage(1);
    }

    private goToPage(page: number) {
        this.unCheckAll();
        this.data.set('page', page);
        const params = {
            page,
            q: this.data.get('q'),
            limit: this.data.get('limit')
        };
        this.getUsers(params);
        this.getUsersCount(params);
    }

    onPageChange(pageParams: { page: number; limit: number; }) {
        this.goToPage(pageParams.page);
    }

    private rejectDisabledUsers(users: IUser[]): IUser[] {
        const disabledUsers = this.data.get('disabledUsers');
        const disabledUserIds = _.map(disabledUsers, 'user_id');
        return _.reject(users, user => _.includes(disabledUserIds, user.user_id));
    }

    private getUsers(params: IUsersParams) {
        userService.getUsers(params).then(users => {
            const oldUsers: IUser[] = this.data.get('users');
            users = this.rejectDisabledUsers(users);
            this.data.splice('users', [0, oldUsers.length, ...users]);
        });
    }

    private getUsersCount(params: IUsersParams) {
        userService.getUsersCount(params).then(count => {
            this.data.set('count', count);
        });
    }

    private saveLatelyUsers(users: IUser[]) {
        const requests = [];
        _.forEach(users, user => {
            requests.push(userService.saveLatelyUser(user.user_id));
        });
        Promise.all(requests);
    }

    submitQ(event: any) {
        if (13 === event.keyCode) {    // 回车
            event.preventDefault(); // 阻止默认行为，防止页面跳转
            this.search();
        }
    }

    submit() {
        const checkedUsers: IUser[] = this.data.get('checkedUsers')
        this.saveLatelyUsers(checkedUsers);
        const callback = this.data.get('callback');
        if (callback) {
            callback(checkedUsers);
        }
        this.cancel();
    }

    cancel() {
        this.data.set('isShow', false);
    }

    toggleCheckAll() {
        const isCheckedAll = !this.data.get('isCheckedAll');
        isCheckedAll ? this.checkAll() : this.unCheckAll();
    }

    private checkAll() {
        if (!this.data.get('isMultiple')) {
            return;
        }
        const users: IUser[] = this.data.get('users');
        _.forEach(users, user => {
            user._is_checked = true;
        });
        this.data.splice('users', [0, users.length, ...users]);
    }

    private unCheckAll() {
        if (!this.data.get('isMultiple')) {
            return;
        }
        const users: IUser[] = this.data.get('users');
        _.forEach(users, user => {
            user._is_checked = false;
        });
        this.data.splice('users', [0, users.length, ...users]);
    }

    checkUser(user: IUser) {
        const users: IUser[] = this.data.get('users');
        if (this.data.get('isMultiple')) {
            const index: number = _.findIndex(users, { user_id: user.user_id });
            user._is_checked = !user._is_checked;
            this.data.splice('users', [index, 1, user]);
        } else {
            _.forEach(users, item => {
                item._is_checked = item.user_id === user.user_id;
            });
            this.data.splice('users', [0, users.length, ...users]);
        }
    }
}